module.exports = __webpack_public_path__ + "static/media/SAINT_6022.5a15b2c3.jpg";